var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4066 5.59967L7.31915 10.7415L1.53283 7.12238C0.703778 6.60368 0.876236 5.34439 1.81397 5.07016L15.5522 1.0469C16.4109 0.795226 17.2067 1.59807 16.9516 2.45955L12.8872 16.1882C12.6087 17.1273 11.3566 17.2951 10.8428 16.4625L7.31645 10.7424",
    stroke: "#1D8BF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMouseIcon);
export default __webpack_public_path__ + "static/media/BlueMouseIcon.6c97ef4e49345ff1024e544fb8ecc9e7.svg";
export { ForwardRef as ReactComponent };